var moment = require('moment')

export const validateEmail = (value) => {
    value = value.trim();
    let regex =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
	  return regex.test(value);
}

export const validateAmount = (value) => {
    value = value.replace(/[.,R]/g, '')

    if (value < 50){
        return false;
    } else {
        return true;
    }
}

export const validateBusinessId = (value) => {

    let regex = /^[0-9\/]+$/
    if (regex.test(value)) {
        if (value.includes('/')) {
            let businessIDRegex = /^(\d{4})\/(\d{6})\/(\d{2})$/
            if (businessIDRegex.test(value)){
                let year = value.substring(0,4);
                var current_year=new Date().getFullYear();
                return !((year < 1900) || (year > current_year));
            }
        } else {
           return true;
        }
    }
    return false

}
